module.exports = __webpack_public_path__ + "static/media/entrance.71fe73e5.jpg";